import {translations} from 'locales/translations';
import {__} from 'utils/messages';

export default {
  invoiceSummary: () => __(translations.invoiceDetailsTab.invoiceSummary, 'Invoice summary'),
};
